import { ErrorHandler } from '@angular/core';
import * as Rollbar from 'rollbar';

import { environment } from '../environments/environment';

// eslint-disable-next-line @typescript-eslint/no-explicit-any

export class RollbarErrorHandler implements ErrorHandler {
  rollbar: Rollbar;

  constructor() {
    this.rollbar = new Rollbar({
      accessToken: '75a76aaab463412a8e2e8a142c53e7f5',
      captureUncaught: true,
      captureUnhandledRejections: true,
    });
  }

  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  handleError(err: any): void {
    this.rollbar.error(err.originalError || err);
    // throw err;
  }
}

// eslint-disable-next-line @typescript-eslint/no-explicit-any
export function errorHandlerFactory(): any {
  if (environment.production) {
    return new RollbarErrorHandler();
  }
  return new ErrorHandler();
}
